import { Routes, Route, Navigate } from 'react-router';
import { styled } from '@mui/material/styles';
import { RoutePath } from '@constants/routes';
import { childRoutePath } from '@helpers/navigation';
import PresenceAnalyticsPage from '@pages/Analytics/Presence';

const Container = styled('div')({
    '@media print': {
        height: 'auto',
        overflow: 'visible',
    },
});

const AnalyticsLocationsRoute = () => (
    <Container>
        <Routes>
            <Route
                path={childRoutePath(RoutePath.LocationsAnalyticsPerformance, RoutePath.LocationsAnalytics)}
                element={<PresenceAnalyticsPage />}
            />
            <Route path="*" element={<Navigate to={RoutePath.LocationsAnalyticsPerformance} replace />} />
        </Routes>
    </Container>
);

export default AnalyticsLocationsRoute;
